<template>
    <div>
        <CheckboxGroup :stacked="true" :initialValue="initialValue" :options="options" v-model="optionsSelected"
            :changed="onChanged" />
    </div>
</template>

<script>
import CheckboxGroup from "@/ui/forms/CheckboxGroup.vue";
import {
    getPayableReceivableDueDateOrderValue,
    getPayableReceivableConfigSelection,
    payableReceivableConfigOptions,
    savePayableReceivableConfigSelection,
} from "../../services/payableReceivableList.config";
import { mapMutations } from "vuex";

export default {
    name: "PayableReceivableConfig",
    components: { CheckboxGroup },
    data() {
        return {
            options: payableReceivableConfigOptions,
            initialValue: getPayableReceivableConfigSelection(),
            optionsSelected: getPayableReceivableConfigSelection(),
        };
    },
    mounted() {
        this.emitConfigEvents();
    },
    methods: {
        ...mapMutations("generic", ["addEvent"]),
        saveConfig() {
            savePayableReceivableConfigSelection(this.optionsSelected);
        },
        onChanged() {
            this.saveConfig();
            this.emitConfigEvents();
        },
        emitConfigEvents() {
            this.emitShowSummaryEvent();
            this.emitShowBalanceEvent();
            this.emitShowClosedEvent();
            this.emitDueDateOrderEvent();
        },
        emitShowSummaryEvent() {
            this.addEvent({
                name: "payableReceivableToggleSummary",
                data: { showSummary: this.optionsSelected.includes("showSummary") },
            });
        },
        emitShowBalanceEvent() {
            this.addEvent({
                name: "payableReceivableToggleBalance",
                data: { showBalance: this.optionsSelected.includes("showBalance") },
            });
        },
        emitShowClosedEvent() {
            this.addEvent({
                name: "payableReceivableToggleClosed",
                data: { showClosed: this.optionsSelected.includes("showClosed") },
            });
        },
        emitDueDateOrderEvent() {
            this.addEvent({
                name: "payableReceivableToggleDueDateOrder",
                data: {
                    configSelection: [...this.optionsSelected],
                    orderValue: getPayableReceivableDueDateOrderValue(this.optionsSelected),
                },
            });
        },
    },
};
</script>
